import { cleanupPageObject } from '.';
import { getAPIUrl } from '../helpers/App';

const searchCancels = {};

const getCancelToken = (key) => {
  if (searchCancels[key]) {
    searchCancels[key].cancel('Operation canceled due to new request.');
  }
  searchCancels[key] = window.axios.CancelToken.source();
  return searchCancels[key].token;
};

export const APIgetPages = params => (
  window.axios.get(getAPIUrl('/pages'), { params })
    .then(response => (response))
);

export const APIcreatePage = page => (
  window.axios.post(getAPIUrl('/pages'), { page: cleanupPageObject(page) })
    .then(response => (response))
);

export const APIgetPage = (pageId, options = {}) => (
  window.axios.get(getAPIUrl(`/pages/${pageId}`), { params: options })
    .then(response => (response))
);

export const APIgetPageTaxonomies = (pageId, options = {}) => (
  window.axios.post(getAPIUrl(`/pages/${pageId}/taxonomies`), {}, options)
);

export const APIgetPageMetadataGroups = (pageId, options = {}) => (
  window.axios.post(getAPIUrl(`/pages/${pageId}/metadata-groups`), {}, options)
);

export const APIgetPageStatuses = (pageId, options = {}) => (
  window.axios.post(getAPIUrl(`/pages/${pageId}/statuses`), {}, options)
);

export const cancelPageSearchRequests = () => {
  Object.values(searchCancels).forEach(source => source.cancel('Operation canceled.'));
};

export const APIsearchPageFiles = (pageId, params) => (
  window.axios.get(getAPIUrl(`/pages/${pageId}/search/files`), {
    cancelToken: getCancelToken(params.only_filters ? 'files-filters' : 'files'),
    params,
  }).then(response => (response))
);

export const APIsearchPageCollections = (pageId, params) => (
  window.axios.get(getAPIUrl(`/pages/${pageId}/search/collections`), {
    cancelToken: getCancelToken('collections'),
    params,
  }).then(response => (response))
);

export const APIgetPageDetails = (pageId, options = {}) => (
  window.axios.get(getAPIUrl(`/pages/${pageId}/details`), { params: options })
    .then(response => (response))
);

export const APIupdatePage = page => (
  window.axios.patch(getAPIUrl(`/pages/${page.id}`), { page: cleanupPageObject(page) })
    .then(response => (response))
);

export const APIdeletePage = pageId => (
  window.axios.delete(getAPIUrl(`/pages/${pageId}`))
    .then(response => (response))
);

export const APIgetPageCollections = (pageId, uuids, options = {}) => (
  window.axios.post(getAPIUrl(`/pages/${pageId}/collections`), { uuids, ...options })
    .then(response => response)
);

export const APIgetPageCollectionFiles = (pageId, collectionUuid, options = {}) => (
  window.axios.get(getAPIUrl(`/pages/${pageId}/collections/${collectionUuid}/files`), { params: options })
    .then(response => response)
);

export const APIgetPageCollectionDetail = (pageId, collectionUuid, options = {}) => (
  window.axios.get(getAPIUrl(`/pages/${pageId}/collections/${collectionUuid}`), { params: options })
    .then(response => response)
);

export const APIgetPageFonts = (pageId, uuids = []) => (
  window.axios.post(getAPIUrl(`/pages/${pageId}/fonts`), { uuids })
    .then(response => response)
);

export const APIgetPageFiles = (pageId, uuids = []) => (
  window.axios.post(getAPIUrl(`/pages/${pageId}/files`), { uuids })
    .then(response => response)
);

export const APIcreatePageDownload = (pageId, params) => (
  window.axios.post(getAPIUrl(`/pages/${pageId}/downloads`), params)
    .then(response => response)
);

export const APIgetPageDownloadSummary = (pageId, params) => (
  window.axios.post(getAPIUrl(`/pages/${pageId}/download_summary`), params)
    .then(response => response)
);

export const APIsearchGoogleFonts = (query = '', limit = 12) => (
  window.axios.get(getAPIUrl('/google-fonts'), { params: { query, limit } })
    .then(response => response)
);

export const APIgetPageTemplates = () => (
  window.axios.get(getAPIUrl(`/page-templates`))
    .then(response => (response))
);
